import { useState, useRef, useEffect, createContext, useContext, useLayoutEffect } from "react";

const HeaderHeightContext = createContext(0);
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export const useHeaderHeight = () => useContext(HeaderHeightContext);

export const HeaderHeightProvider = ({ children }) => {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useIsomorphicLayoutEffect(() => {
     if (headerRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        setHeaderHeight(headerRef.current.offsetHeight);
      });
      resizeObserver.observe(headerRef.current);
      return () => resizeObserver.disconnect();
    }
  }, []);

  return (
    <HeaderHeightContext.Provider value={headerHeight}>
      {children(headerRef, headerHeight)}
    </HeaderHeightContext.Provider>
  );
};
